module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0157.jpg?v=1ad008f8";